export class ActiveToggle {

    constructor() {
        // For toggling mobile CMS links on most pages.
        this.wireUpToggle(".cms-links h3", ".cms-links");
    }

    private wireUpToggle(clickSelector: string, elementToToggleSelector: string): void {
        let clickElement = <HTMLElement>document.querySelector(clickSelector);

        if (clickElement) {
            let toggleElement = document.querySelector(elementToToggleSelector);

            if (toggleElement) {
                clickElement.onclick = (e) => {
                    toggleElement.classList.toggle("active");
                }
            }
        }
    }
}

new ActiveToggle();